import { getPrivacyPolicyUrl } from "@certn/utils";
import { useTranslation } from "react-i18next";

import { HelpAndPrivacyLinkItem } from "./HelpAndPrivacyLinkItem";
import { useLanguage } from "../../../hooks/useLanguage";

export function PrivacyPolicy() {
  const { t } = useTranslation();
  const { currentLanguageLabel } = useLanguage();
  const privacyPolicyUrl = getPrivacyPolicyUrl(currentLanguageLabel);

  return (
    <HelpAndPrivacyLinkItem
      testID="help-and-privacy-privacy-policy-view-button"
      item={t("Privacy policy")}
      description={t("Learn about how we protect your privacy here")}
      linkText={t("View")}
      link={privacyPolicyUrl}
    />
  );
}
